import {
  getUrlParameterByName,
} from 'config/utils';

export function getEMIAmount (p, r, n) {
  return (p * r / (1 - (Math.pow(1 / (1 + r), n)))).toFixed(2);
}

export function getTotalEMIAmount (emi, months) {
  return (emi * months).toFixed(2);
}

export const getPaymentOptionKey = ({ type, name }) =>
  `${type}_${name.toLowerCase().replace(/\s/g, '')}`;

export const getMatchingPaymentOption = (paymentOptions) => {
  const directPaymentMode = getUrlParameterByName('directPaymentMode');
  if(!directPaymentMode) {
    return null;
  }

  return paymentOptions[(Object.keys(paymentOptions).filter((currentOption) =>
    removeSpaceAndLowercaseSring(paymentOptions[currentOption]['name']) === removeSpaceAndLowercaseSring(directPaymentMode)))[0]];

};

const removeSpaceAndLowercaseSring = (textString) => textString.replace(/\s/g, '').toLowerCase();



// WEBPACK FOOTER //
// ./src/payments/utils/FinalizePurchaseUtils.js